/**
 * Shared expandable accordions for about page (team + jobs)
 */

let aboutAccordionAbort = null;

export function initAboutTeam() {
  const accordions = document.querySelectorAll(".js-about-accordion");

  if (accordions.length === 0) {
    return;
  }

  // Re-bind after Swup — previous page's listeners are gone with #main.
  aboutAccordionAbort?.abort();
  aboutAccordionAbort = new AbortController();
  const { signal } = aboutAccordionAbort;

  accordions.forEach((item) => {
    const header = item.querySelector(".c-about-accordion__header");

    if (!header) {
      return;
    }

    item.setAttribute("data-state", "closed");

    header.addEventListener(
      "click",
      (e) => {
        e.preventDefault();

        const isClosed = item.getAttribute("data-state") === "closed";
        item.setAttribute("data-state", isClosed ? "open" : "closed");
      },
      { signal }
    );
  });
}
